// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"728a3353","356":"a442a818","418":"a5890e2f","606":"1e85617f"}[chunkId] + ".css";
};